import { Grid } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { PlanDescriptionField } from './PlanDescriptionField';
import { PlanField } from './PlanField';

const useStyles = makeStyles()(theme => ({
  dateContainer: {
    minWidth: '350px',
  },
  gridContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    padding: '10px',
    minWidth: '350px',
  },
  root: {
    flexGrow: 1,
  },
}));

export const PtoMod = () => {
  const { classes } = useStyles();
  return (
    <>
      <div className={classes.root}>
        <Grid container direction="column" spacing={4} className={classes.gridContainer}>
          <Grid xs={12} item className={classes.dateContainer}>
            <PlanField />
          </Grid>
          <Grid xs={12} item className={classes.dateContainer}>
            <PlanDescriptionField />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
